export class FacebookSDKError extends Error {
    constructor(message?: string) {
        super(message);

        this.name = 'FacebookSDKError';
    }
}
